import { Action } from '@/_core/fluxstore/types';
import { SnackbarState, ISnackbarMessage } from '../types';

import { useAppSnackbarModule } from '..';
const { registerReducer } = useAppSnackbarModule();

export class AddSnackbarmessage extends Action<SnackbarState> {
    public static ACTION_TYPE = 'SnackbarState::AddSnackbarmessage';

    public constructor(public message: ISnackbarMessage) {
        super(AddSnackbarmessage.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: SnackbarState, action: AddSnackbarmessage): void => {
    state.message.isShown = false;
    setTimeout(() => {
        state.message.message = action.message.message;
        state.message.timeout = action.message.timeout;
        state.message.type = action.message.type;
        state.message.actionText = action.message.actionText;
        state.message.onAction = action.message.onAction;
        state.message.isShown = true;
    }, 250);
};

//@ts-ignore
registerReducer(AddSnackbarmessage.ACTION_TYPE, reducer);
